import { ThunkAction } from "redux-thunk";
import { Action } from "redux";

import { RootState } from "app/redux/reducer";
import { ActivityTypeService } from "./service";
import { showMessage, toggleConfirmDialog, toggleLoader } from "app/redux/system/actions";
import { initialPageData } from "app/redux/page/actions";
import { MessageType } from "app/redux/system/types";
import { IActivityType } from "./types";
import { HttpStatusCode, IList, IListFilter } from "app/shared";
import { mapActivityTypeFromEntity, mapActivityTypeFromModel } from "./mapping";

type ThunkResult<R> = ThunkAction<R, RootState, {}, Action>;

export function getActivityType(id: string, language?: string, notFill?: boolean): ThunkResult<Promise<any>> {
    return async (dispatch, getState) => {
        const service = new ActivityTypeService();
        dispatch(toggleLoader());
        const response = await service.getActivityType(id, language || getState().system.defaultLanguage);
        dispatch(toggleLoader());

        if (response.status === HttpStatusCode.OK) {
            const mapped = mapActivityTypeFromEntity(response.data.attributes["activityType"] || {});

            if (!notFill) {
                dispatch(initialPageData<IActivityType>(mapped));
            }

            return mapped;
        }
        dispatch(showMessage("Bir hata oluştu. Servis sağlayıcınızla iletişime geçin ya da daha sonra tekrar deneyiniz!", "Bir Hata Oluştu!", MessageType.ERROR))
        return false;
    };
}

export function getActivityTypeByLanguage(pageData: IActivityType, language: string, isOverride?: boolean): ThunkResult<Promise<any>> {
    return async (dispatch, getState) => {
        const service = new ActivityTypeService();
        dispatch(toggleLoader());
        const response = await service.getActivityType(pageData.id as string, isOverride ? getState().system.defaultLanguage : language);
        if (response.status === HttpStatusCode.OK) {
            const mapped = mapActivityTypeFromEntity(response.data.attributes["activityType"] || {});
            const data = { ...mapped, language: language, id: isOverride ? pageData.id : mapped.id };
            dispatch(initialPageData<IActivityType>(data));
            if (isOverride) {
                dispatch(updateActivityType(data));
            }
            dispatch(toggleLoader());
            return true;
        }
        else {
            dispatch(toggleConfirmDialog(true, {
                title: "Uyarı!",
                text: `Geçerli dil'e (${language}) ait bir kayıt bulunamadı. Varsayılan dil üzerinden seçtiğiniz dile göre kayıt oluşturulsun mu?`,
                button: {
                    approveText: "Varsayılan Dil'den Oluştur"
                },
                callback: () => {
                    dispatch(createActivityType({ ...pageData, id: "", title: `${pageData.title} (${language.toUpperCase()})`, language })).then(res => {
                        if (res) {
                            dispatch(getActivityType(res.id as string, language));
                        }
                    });
                    return true;
                }
            }))
        }
        dispatch(toggleLoader());
        return false;
    };
}


export function getActivityTypes(options: IListFilter): ThunkResult<Promise<boolean>> {
    return async (dispatch) => {
        const service = new ActivityTypeService();
        dispatch(toggleLoader());
        const response = await service.getActivityTypes(options);
        dispatch(toggleLoader());
        if (response.status === HttpStatusCode.OK) {
            const mapped = (response?.data?.attributes?.list || []).map((item) =>
                mapActivityTypeFromEntity(item)
            );
            dispatch(initialPageData<IList<IActivityType[]>>({
                list: mapped,
                pageSize: response.data.attributes.pageSize,
                totalCount: response.data.attributes.total,
                pageCount: Math.ceil(response.data.attributes.total / response.data.attributes.pageSize)
            }));
            return true;
        }
        return false;
    };
}

export function getActivityTypesForLocal(language: string): ThunkResult<Promise<IActivityType[]>> {
    return async () => {
        const service = new ActivityTypeService();
        const response = await service.getActivityTypes({ page: 1, pageSize: 100, descending: false, language });
        if (response.status === HttpStatusCode.OK) {
            const mapped = (response?.data?.attributes?.list || []).map((item) =>
                mapActivityTypeFromEntity(item)
            );
            return mapped;
        }
        return [];
    };
}

export function createActivityType(request: IActivityType): ThunkResult<Promise<IActivityType | null>> {
    return async (dispatch) => {
        const service = new ActivityTypeService();
        dispatch(toggleLoader());
        const response = await service.createActivityType(mapActivityTypeFromModel(request));
        dispatch(toggleLoader());
        if (response.status === HttpStatusCode.OK) {
            return mapActivityTypeFromEntity(response.data.attributes["activityType"] || {});
        }
        return null;
    };
}

export function updateActivityType(request: IActivityType): ThunkResult<Promise<boolean>> {
    return async (dispatch) => {
        const service = new ActivityTypeService();
        dispatch(toggleLoader());
        const response = await service.updateActivityType(mapActivityTypeFromModel(request));
        dispatch(toggleLoader());
        if (response.status === HttpStatusCode.OK) {
            return true;
        }
        return false;
    };
}

export function deleteActivityType(id: string): ThunkResult<Promise<boolean>> {
    return async (dispatch) => {
        const service = new ActivityTypeService();
        dispatch(toggleLoader());
        const response = await service.deleteActivityType(id);
        dispatch(toggleLoader());
        if (response.status === HttpStatusCode.OK) {
            return true;
        }
        dispatch(showMessage("Bir hata oluştu. Servis sağlayıcınızla iletişime geçin ya da daha sonra tekrar deneyiniz!", "Bir Hata Oluştu!", MessageType.ERROR))
        return false;
    };
}